export const removeDocumentFromSpecificUser = (
  array,
  memberUuid,
  documentUuid,
) => {
  return array.map(item => {
    if (item.member && item.member.uuid === memberUuid) {
      return {
        ...item,
        documents: Array.isArray(item.documents)
          ? item.documents.filter(doc => doc.uuid !== documentUuid)
          : item.documents,
      }
    }
    return item
  })
}
